export const locales = {
	ca: cb => require([], 
		() => cb(require.context('js', true, /locale\/ca.yml$/))),
	es: cb => require([], 
		() => cb(require.context('js', true, /locale\/es.yml$/))),
	fr: cb => require([], 
		() => cb(require.context('js', true, /locale\/fr.yml$/))),
	mn: cb => require([], 
		() => cb(require.context('js', true, /locale\/mn.yml$/))),
	pt: cb => require([], 
		() => cb(require.context('js', true, /locale\/pt.yml$/)))
};

export const routes = {
	account: {
		address:
			() => import('account/address'),
		addressList:
			() => import('account/address-list'),
		conf:
			() => import('account/conf')
	},
	admin: {
		accessLog:
			() => import('admin/access-log'),
		connections:
			() => import('admin/connections'),
		items:
			() => import('admin/items'),
		links:
			() => import('admin/links'),
		photos:
			() => import('admin/photos'),
		queries:
			() => import('admin/queries'),
		users:
			() => import('admin/users'),
		visits:
			() => import('admin/visits')
	},
	agencies: {
		packages:
			() => import('agencies/packages')
	},
	cms: {
		about:
			() => import('cms/about'),
		contact:
			() => import('cms/contact'),
		home:
			() => import('cms/home'),
		location:
			() => import('cms/location'),
		why:
			() => import('cms/why')
	},
	ecomerce: {
		basket:
			() => import('ecomerce/basket'),
		catalog:
			() => import('ecomerce/catalog'),
		checkout:
			() => import('ecomerce/checkout'),
		confirm:
			() => import('ecomerce/confirm'),
		invoices:
			() => import('ecomerce/invoices'),
		orders:
			() => import('ecomerce/orders'),
		ticket:
			() => import('ecomerce/ticket'),
		pending:
			() => import('ecomerce/pending')
	},
	news: {
		new:
			() => import('news/new'),
		news:
			() => import('news/news')
	},
	reports: {
		shelves:
			() => import('reports/shelves')
	}
};
